import React from 'react';
import { IconProps } from './types';

const IncentiveMoneyIcon: React.FC<IconProps> = props => {
  const { height = '24', width = '24' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle opacity="0.2" cx="12" cy="12" r="12" fill="#FFC800" />
      <g opacity="0.9">
        <path
          d="M16.0672 8.40625L18.5539 8.63232L17.4236 10.2148V11.119L19.4582 12.7015L20.3624 18.7991H11.7842L12.6884 12.7015L14.723 11.119V10.2148L13.5927 8.63232L16.0794 8.40625H16.0672Z"
          fill="white"
        />
        <path d="M17.778 9.63864L18.4256 8.73438H13.7638L14.4114 9.63864H17.778Z" fill="#BBD8FF" />
        <path
          d="M16.5864 11.1155C16.5864 11.1155 17.9245 12.4597 17.9734 13.8405C18.0222 15.2213 17.6495 18.7895 17.6495 18.7895H20.2646L19.5131 13.7061C19.5131 13.7061 19.5436 12.5085 17.3318 11.1094H16.5864V11.1155Z"
          fill="#BBD8FF"
        />
        <path
          d="M17.4236 11.125H14.7169"
          stroke="#21002A"
          strokeWidth="0.5625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.3987 10.3047H14.7413"
          stroke="#21002A"
          strokeWidth="0.5625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.7169 11.1195V10.2153L13.5865 8.63281H18.5539L17.4236 10.2153V11.1195L18.5294 11.981C19.1221 12.4454 19.5192 13.1175 19.6292 13.8629L20.3624 18.7996H16.0733"
          stroke="#21002A"
          strokeWidth="0.5625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9064 14.3438H17.5092"
          stroke="#21002A"
          strokeWidth="0.46875"
          strokeLinejoin="round"
        />
        <path
          d="M14.937 15.1797H17.5398"
          stroke="#21002A"
          strokeWidth="0.46875"
          strokeLinejoin="round"
        />
        <path
          d="M15.7739 14.3438C16.2505 14.3438 16.6293 14.7348 16.6293 15.1991C16.6293 15.6635 16.2444 16.0545 15.7739 16.0545C15.6517 16.0545 15.5234 16.024 15.4196 15.9812L16.7087 17.2704"
          stroke="#21002A"
          strokeWidth="0.46875"
          strokeLinejoin="round"
        />
        <path
          d="M9.34018 5.125L12.5845 5.41827L11.112 7.48341V8.66262L13.7637 10.7278L14.9429 18.6828H3.73743L4.91663 10.7278L7.56832 8.66262V7.48341L6.09584 5.41827L9.34018 5.125Z"
          fill="white"
        />
        <path d="M11.5703 6.73219L12.4134 5.54688H6.328L7.17117 6.73219H11.5703Z" fill="#BBD8FF" />
        <path
          d="M11.106 8.65625H7.56836"
          stroke="#21002A"
          strokeWidth="0.5625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.0624 7.60938H7.59888"
          stroke="#21002A"
          strokeWidth="0.5625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5784 5.42188L11.1059 7.48701V8.66622L12.5479 9.79044C13.3238 10.3953 13.8371 11.2751 13.9837 12.2466L14.9368 18.6925H3.73743L4.69057 12.2466C4.8372 11.2751 5.35043 10.3953 6.12639 9.79044L7.56832 8.66622V7.48701L6.09584 5.42188H12.5784Z"
          stroke="#21002A"
          strokeWidth="0.5625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.53796 12.5234H11.2528"
          stroke="#21002A"
          strokeWidth="0.5625"
          strokeLinejoin="round"
        />
        <path
          d="M7.58069 13.7188H11.2955"
          stroke="#21002A"
          strokeWidth="0.5625"
          strokeLinejoin="round"
        />
        <path
          d="M8.77823 12.5234C9.45643 12.5234 10.0002 13.0794 10.0002 13.7454C10.0002 14.4114 9.45032 14.9674 8.77823 14.9674C8.60104 14.9674 8.42386 14.9246 8.27722 14.8574L10.1163 16.6965"
          stroke="#21002A"
          strokeWidth="0.5625"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default IncentiveMoneyIcon;
